module.exports = __webpack_public_path__ + "root-c2082cbd/XING-Sans-Bold-Italic-36a68d3c5a869c8bdf713f20b95e76d7.woff";